/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/photo'
export default icon
